module.exports = __webpack_public_path__ + "static/media/sopt5kz.8d908cda.pdf";